module.exports = __webpack_public_path__ + "static/media/review_4.6d627f32.png";